import { render, staticRenderFns } from "./EditCommittemember.vue?vue&type=template&id=864a6854&scoped=true"
import script from "./EditCommittemember.vue?vue&type=script&lang=js"
export * from "./EditCommittemember.vue?vue&type=script&lang=js"
import style0 from "./EditCommittemember.vue?vue&type=style&index=0&id=864a6854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864a6854",
  null
  
)

export default component.exports